import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../routes/Route.name";
import {
  actionFetchHealthTips,
  actionSetPageHealthTips,
} from "../../actions/HealthTips.action";
import history from "../../libs/history.utils";


const useHealthTipsListHook = ({}) => {

  const [editData, setEditData] = useState(null);
  const dispatch = useDispatch();
  const isMountRef = useRef(false);
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.health);

  useEffect(() => {
    dispatch(
      actionFetchHealthTips(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
        }
      )
    );
    isMountRef.current = true;
  }, []);

  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageHealthTips(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchHealthTips(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      dispatch(actionSetPageHealthTips(1));
      dispatch(
        actionFetchHealthTips(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );

  const handleDetail = useCallback((type) => {
    history.push(`${RouteName.HEALTH_DETAIL}${type?.id}`);
  }, []);

  const handleCreate = useCallback(() => {
    history.push(RouteName.HEALTH_CREATE);
  }, []);

  const handleEdit = useCallback((type) => {
    history.push(`${RouteName.HEALTH_UPDATE}${type?.id}`);
  }, []);


  const handleCopy = useCallback((type) => {
    history.push(`${RouteName.HEALTH_UPDATE}${type?.id}`,{"is_duplicate":true});
  }, []);
  
 
  const configFilter = useMemo(() => {
    return [
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["ACTIVE", "INACTIVE", "SCHEDULED"],
      },
    ];
  }, []);

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleDetail,
    editData,
    configFilter,
    handleCreate,
    handleEdit,
    handleCopy
  };
};

export default useHealthTipsListHook;
